import _ from 'lodash'
import generateShortId from '@/utils/generateId'

/**
 * 加工产品信息列表，以适配表单数据格式
 * @param {array} products
 * @param {{}} demand
 */
export const cookProducts = (products, demand) => {
  const platformList = demand.platform.split(',')

  return products.map(product => {
    const newProduct = _.pick(product, [
      'id',
      'app_url',
      'app_id',
      'app_name',
      'demand_id',
      'package_name',
      'offer_uuid',
      'platform'
    ])
    newProduct.mtg_daily_cost = product.daily_cost
    newProduct._id = generateShortId()

    if (platformList.length > 0) {
      if (product.platform === 'ios') {
        newProduct.title = 'iOS产品信息'
      }
      if (product.platform === 'android') {
        newProduct.title = 'Android产品信息'
      }
    }

    // 将 int 类型的初始值修改为空字符串，便于 UI 处理
    _.each(newProduct, (value, key) => {
      if (value === 0) newProduct[key] = ''
    })

    return newProduct
  })
}

/**
 * 加工创意要求列表，以适配表单数据格式
 * @param {{}[]} creationTasks
 * @param {{}} demand
 */
export const cookCreationList = (creationTasks, demand) => {
  const strToArr = str => {
    if (!str) return []
    return str.trim() ? str.split(',') : []
  }

  return creationTasks.map((creation, index) => {
    const newCreation = Object.assign(
      {},
      _.pick(creation, ['id', 'demand_id']),
      {
        // 交互素材的类型必需是数组
        channel: demand.type === 2 ? Number(creation.channel_ids) : strToArr(creation.channel_ids).map(item => Number(item)),
        type: creation.creation_type ? Number(creation.creation_type) : '',
        languages: strToArr(creation.languages),
        sizes: strToArr(creation.creation_sizes),
        _id: generateShortId() // 用于 vue 列表循环 key
      }
    )

    // 将 int 类型的初始值修改为空字符串，便于 UI 处理
    _.each(newCreation, (value, key) => {
      if (value === 0) newCreation[key] = ''
    })

    return newCreation
  })
}
